import React, { Component } from "react";
import { BlueBtn } from "components/Controls";
import { connect } from "react-redux";
import { selectOffer, nextStep, setSelectedOffer } from "../../actions";
import { mergeRight } from "ramda";
import { OfferView, BuyoutInfo } from "components/DataDisplay";
import { reduxForm, Field, change } from "redux-form";
import PropTypes from "prop-types";
import OfferHeader from "../OfferHeader";
import { buildOfferData } from "containers/MultistepForm/helpers";
import { appRequestSelector, trendingsVisitID } from "../../selectors";
import { createStructuredSelector } from "reselect";
import OfferBlock from 'components/DataDisplay/OfferBlock';
import { RadioField } from "components/Fields";
import { details } from "./details";
import { paymentFrequency } from "utils/helpers";

import "./styles.scss";

class OwnleaseOffer extends Component {
  state = {
    loading: false,
    selectedOffer: null,
    detailsShown: false,
    options: [],
    selectedOption: null
  };

  componentDidMount = () => {
    const { offer } = this.props;
    this.setState({
      options: offer.options,
    });
    const defaultSelected = offer.options[0];
    if (offer.options.length > 1) {
      this.props.dispatch(
        change(
          "form",
          "paymentPeriod",
          defaultSelected.payment_period.toString()
        )
      );
    }
    this.setSelected(defaultSelected);
  };

  setSelected = (option) => {
    const { offer } = this.props;

    option = mergeRight(option, {
      app_id: offer.app_id,
      provider: offer.provider,
      offer_id: option.offer_id,
      payment_schedule: offer.payment_schedule,
      specific_provider_name: offer.provider,
      cart_total: offer.cart_total,
      approved_amount: option.maxLoan,
      promo: offer.promo
    });
    this.props.getSelectedOffer(option);
    this.setState({ selectedOption: option });
  };

  renderBuyout = () => {
    const {offer} = this.props;

    return (
      <>
        {offer.promo && (
          <div className="early-ownership-options">
            <span className="options-header">${offer.promo} Lease Credit</span>
            <BuyoutInfo
              title={''}
              text={
                <ul style={{margin: 0, paddingInlineStart: '24px'}}>
                  <li>{`Stay current through Day 120 of your lease and receive a $${offer.promo} credit applied to your account.`}</li>
                  <li>{`This $${offer.promo} credit still applies if you exercise an early payoff option after Day 120.`}</li>
                  <li>Limit one per person.</li>
                </ul>
              }
            />
          </div>
        )}
        <div className="early-ownership-options">
          <span className="options-header">Early Ownership Options</span>
          <BuyoutInfo
            title={'110-Day Option'}
            text={'Become the owner early by paying off within the first 110 days. The early payoff option allows you to become the owner of the leased item before the ownership date, by paying off in full, the cash price of the item, applicable sales tax, early payoff option fee, and applicable fees within the first 110 days of your lease-to-own agreement. Your exact early payoff option period is provided to you in your lease agreement.'}
          />
        </div>
        <div className="early-ownership-options">
          <span className="options-header">Early Buyout Option</span>
          <BuyoutInfo
            title={'Save money when you pay your lease off early.'}
            text={'Pay off your lease early after the 110-day option period and save. Early payoff options can be completed through the customer portal.'}
          />
        </div>
      </>
  )
  }

  renderPaymentPeriodField = ({input, meta}) => {
    return (
      <div className="offer-block-wrapper offer-block offer-block--100 flex">
        <div className="offer-item__title__pf">Payment Frequency:</div>
        <RadioField
          {...input}
          meta={meta}
          options={this.paymentScheduleOptions()}
          customChange={this.setPaymentSchedule}
        />
      </div>
    );
  };

  setPaymentPeriod = (value) => {
    const {offer} = this.props;

    const option = offer.options.find(
      (option) => option.payment_period === parseInt(value)
    );

    this.setSelected(option);
  };

  paymentPeriodOptions = () => {
    const { offer } = this.props;

    return offer.options.map((option) => {
      return {
        value: `${option.payment_period.toString()} Months`,
        key: option.payment_period.toString(),
      };
    });
  };

  renderPaymentPeriodBlock = () => {
    const { offer } = this.props;
    const { selectedOption } = this.state;

    if (offer.options.length === 1) {
      return <OfferBlock
        row={[{
          title: 'Payment Period',
          value: `${selectedOption.payment_period} Months`
        }]}
      />
    } else {
      return (<div className="offer-block offer-block--100">
        <div className="offer-item offer-item__column">
          <div className="offer-item__title">Payment Period:</div>
          <Field
            name="paymentPeriod"
            component={this.renderPaymentPeriodField}
          />
        </div>
      </div>)
    }
  }

  submitForm = (values) => {
    const { selectedOption } = this.state;
    const { selectOffer, logContinueEvent } = this.props;

    this.setState({ loading: true })
    selectOffer({selectedOffer: selectedOption});
    logContinueEvent()
  };


  render() {
    const { loading, selectedOption } = this.state;
    const { handleSubmit, valid, available, isExpanded, offer, toggleExpanded } = this.props;

    if (!selectedOption) {
      return '';
    }
    return (
      <div className="expanded-block-component__expanded-content ownlease">
        <OfferHeader
          available={available}
          isExpanded={isExpanded}
          dueToday={0}
          specificProviderName={offer.specific_provider_name}
          paymentPeriod={`${selectedOption.payment_period} Months`}
          paymentFrequency={selectedOption.payment_period_rate.replace(/\s/g, '').toLowerCase()}
          promo={offer.promo}
          toggleExpanded={toggleExpanded}
        />
        {isExpanded && (

          <form
            onSubmit={handleSubmit(this.submitForm)}
            className="application-offer"
          >
            <div className="step3__recommended-offer-plan offer-plan__top flex flex--wrap">
              <OfferView offerData={buildOfferData(selectedOption, details())} />
              {this.renderPaymentPeriodBlock()}
            </div>

            {this.renderBuyout()}

            <BlueBtn
              customClass="step3__recommended-content-btn"
              loading={loading}
              disabled={!available || !valid}
              type="submit"
            >
              Continue with Own.lease
            </BlueBtn>
          </form>

        )}
      </div>
    );
  }
}

OwnleaseOffer.propTypes = {
  offer: PropTypes.object.isRequired,
  available: PropTypes.bool
};

OwnleaseOffer.defaultProps = {
  available: true
};

const mapStateToProps = createStructuredSelector({
  appRequest: appRequestSelector(),
  visitID: trendingsVisitID()
});

const mapDistpatchToProps = (dispatch) => {
  return {
    selectOffer: (data) => dispatch(selectOffer(data)),
    nextStep: value => dispatch(nextStep(value)),
    setSelectedOffer: value => dispatch(setSelectedOffer(value))
  };
};

OwnleaseOffer = connect(mapStateToProps, mapDistpatchToProps)(OwnleaseOffer);

OwnleaseOffer = reduxForm({
  form: "form",
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(OwnleaseOffer);

export default OwnleaseOffer;
